<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item custom">
    <h1>მარტივი რჩევები სამგზავრო სავარძლის შერჩევისთვის</h1>
    <h6>აპრლი 2025</h6>
    <br />
    <p>
      <mark class="mark-blue" style="background-color: #004083; font-family: inherit; font-size: inherit;">
        <b> თიბისი ლიზინგი YOUR CAR SEAT-ის მხარდამჭერია.</b>
      </mark>
    </p>

    <p>
      იცოდით, რომ ბავშვთა სამგზავრო სავარძლის, ე.წ „ქარსითის“ გამოყენება 0-დან 12 წლამდე ბავშვებისთვის არის
      რეკომენდებული? ის 90%-ით იცავს პატარის უსაფრთხოებას ავტოსაგზაო შემთხვევისას. საკითხის გარშემო ცნობიერების
      ამაღლების მიმართულებით საქართველოში საზოგადოებრივი ორგანიზაცია <b class="light-blue">YOUR CAR SEAT</b> მუშაობს,
      რომლის მიზანიც მშობლებისთვის ინფორმაციის სრულფასოვანი მიწოდება, მოხალისეობრივი კონსულტაციები და დახმარებაა.
    </p>

    <img src="../../../../assets/blog/car-seat/img1.jpg" alt="" />

    <p>
      <i class="subhead capital light-blue">
        <b style="font-size: 20px;">დეტალები, რომელიც უნდა ვიცოდეთ ქარსითის შესარჩევად:</b>
      </i>
    </p>

    <p class="list-item">
      როგორც აღვნიშნეთ, ის 0-12 წლის ბავშვების უსაფრთხო მგზავრობისთვის აუცილებელია;
    </p>
    <p class="list-item">
      სავარძლები წონისა და სიმაღლის მიხედვით ჯგუფებად იყოფა;
    </p>
    <p class="list-item">
      ის სანდო მომწოდებლისგან უნდა შეიძინოთ;
    </p>
    <p class="list-item">
      აუცილებელია გავლილი ჰქონდეს სპეციალური შემოწმება - Crash test, რომელიც ადასტურებს, რომ ავტოსაგზაო შემთხვევისას ის
      ეფექტიანად დაიცავს ბავშვს;
    </p>

    <p class="list-item">
      ახალშობილისთვის განკუთვნილია კალათის ფორმის სამგზავრო სავარძელი (0-13 კგ), რომელიც ემბრიონის ფორმას იმეორებს და
      ყველა მხრიდან იცავს ბავშვს;
    </p>
    <p class="list-item">
      გამართლებულია 0-36 კგ-სთვის განკუთვნილი სავარძლის შეძენაც;
    </p>
    <p class="list-item">
      არ არის რეკომენდებული მეორადი სავარძლის შეძენა, რადგან მას გამოყენების ვადა აქვს;
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-green" style="background-color: #507aac;">
      <div class="container blog-item custom" style="padding: 0;">
        <p>
          <i class="subhead capital yellow">
            <b style="font-size: 20px;">დეტალები, რომელიც უნდა ვიცოდეთ ქარსითის შესარჩევად:</b>
          </i>
        </p>
        <p class="list-item yellow" style="color: white;">
          რა თქმა უნდა, აუცილებელია ღვედების შეკვრა - წინააღმდეგ შემთხვევაში ქარსითის ეფექტურობა ირღვევა;
        </p>
        <p class="list-item yellow" style="color: white;">
          ღვედი არ უნდა იყოს გადაგრეხილი;
        </p>
        <p class="list-item yellow" style="color: white;">
          უმჯობესია, თუ სავარძელი მანქანაში მოძრაობის საპირისპირო მიმართულებით დამაგრდება;
        </p>
        <img style="max-width: 1000px;" src="../../../../assets/blog/car-seat/img2.jpg" alt="" />
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      <mark class="mark-blue" style="background-color: #004083; font-family: inherit; font-size: inherit;">
        ეს ის მცირე დეტალებია, რომელიც სავარძლის შერჩევაში დაგეხმარებათ, თუმცა თუ უფრო დეტალური ინფორმაცია გჭირდებათ,
        შეგიძლიათ
        <b>YOUR CAR SEAT-ს დაუკავშირდეთ;</b>
      </mark>
    </p>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item custom">
    <h1>
      Simple Tips for Choosing a Child Car Seat
    </h1>
    <h6>April 2025</h6>
    <br />
    <p>
      <mark class="mark-blue" style="background-color: #004083; font-family: inherit; font-size: inherit;">
        <b>TBC Leasing is a supporter of YOUR CAR SEAT. </b>
      </mark>
    </p>

    <p>
      Did you know that using a child car seat — the so-called "car seat" is recommended for children aged 0 to 12
      years? It protects a child’s safety in a car accident by up to 90%. To raise awareness on this issue in Georgia,
      the public organization <b class="light-blue">YOUR CAR SEAT</b> works to provide parents with comprehensive
      information, voluntary consultations, and assistance.
    </p>

    <img src="../../../../assets/blog/car-seat/img1.jpg" alt="" />

    <p>
      <i class="subhead capital light-blue">
        <b style="font-size: 20px;">Key Details to Know When Choosing a Car Seat: </b>
      </i>
    </p>

    <p class="list-item">
      As mentioned, it is essential for the safe transportation of children aged 0 to 12 years.
    </p>
    <p class="list-item">
      Seats are categorized into groups based on the child’s weight and height.
    </p>
    <p class="list-item">
      It should be purchased from a reliable supplier.
    </p>
    <p class="list-item">
      It is crucial that the seat has passed a special safety check — a Crash Test — confirming its effectiveness in
      protecting the child during a car accident.
    </p>

    <p class="list-item">
      For newborns, a basket-style car seat (0–13 kg) is recommended; it mimics the shape of an embryo and protects the
      baby from all sides.
    </p>
    <p class="list-item">
      Seats designed for children weighing 0–36 kg are also suitable.
    </p>
    <p class="list-item">
      Buying a used car seat is not recommended due to limited usage lifespan.
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-green" style="background-color: #507aac;">
      <div class="container blog-item custom" style="padding: 0;">
        <p>
          <i class="subhead capital yellow">
            <b style="font-size: 20px;">Additional Important Details for Choosing a Car Seat: </b>
          </i>
        </p>
        <p class="list-item yellow" style="color: white;">
          The seat belts must be fastened correctly — otherwise, the car seat will not provide proper protection.
        </p>
        <p class="list-item yellow" style="color: white;">
          The belt should not be twisted.
        </p>
        <p class="list-item yellow" style="color: white;">
          It is preferable to install the seat facing the rear of the vehicle.
        </p>
        <img style="max-width: 1000px;" src="../../../../assets/blog/car-seat/img2.jpg" alt="" />
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      <mark class="mark-blue" style="background-color: #004083; font-family: inherit; font-size: inherit;">
        These are the key details that will help you choose the right car seat. However, if you need more detailed
        information, you can contact <b>YOUR CAR SEAT directly.</b>
      </mark>
    </p>
  </div>
</ng-container>
